import React, { useEffect, useState } from "react";
import { inject, observer } from "mobx-react";
import { prepareSheetSchema } from "../lib/utils";
import Progress from "../Progress";

const SubsheetsTaskAction = ({
  subsheets = [],
  onRequestParams,
  onComplete,
  //
  assistantStore,
  chatHelpersStore,
  component,
}) => {
  const [progress, setProgress] = useState({label: "Creating subsheets"})

  const handleComplete = async (...params) => {
    typeof onComplete === "function" && (await onComplete(...params));
  };

  const createSubsheets = async (subsheetsByParentSheetId) => {
    // load all sheets
    await assistantStore.fetchAndLoadSheets();

    const createdSubsheets = [];

    // create all subsheets per parent sheet
    for (const parentSheetId in subsheetsByParentSheetId) {
      const subsheets = subsheetsByParentSheetId[parentSheetId];

      const parentSheet = assistantStore.sheetsById[parentSheetId];

      if (!subsheets || !parentSheet) continue;

      const createdSubsheetFields = [];

      // create all subsheets with parentSheetId
      for (const subsheet of subsheets) {
        const payload = {
          fields: subsheet.fields,
          sheetName: subsheet.sheetName,
          parentSheetId: parentSheet.id,
        };

        const res = await chatHelpersStore.createSubsheetApiHelper(payload);

        createdSubsheets.push({
          ...res.data,
          ...payload,
        });

        // append all created subsheet fields
        createdSubsheetFields.push({
          field_name: subsheet.sheetName,
          field_type_id: 6,
          attributes: {
            ...subsheet.attributes,
            subsheet_fields: subsheet.fields,
            sub_list_id: res.data?.list_id,
          },
        });
      }

      if (createdSubsheetFields.length) {
        const { list_name, columns } = prepareSheetSchema({
          fields: createdSubsheetFields,
          sheetName: parentSheet.name,
        });

        // save the subsheet info to parent sheet as fields
        await assistantStore.addColumnsToSheet({
          columns: columns.map((column) => {
            column.column_id = 0;
            column.options = JSON.stringify([column.options]);
            return column;
          }),
          list_name,
          list_id: parentSheet.id,
        });
      }
    }

    return createdSubsheets;
  };

  const handleOnLoad = async () => {
    try {
      // load all sheets
      await assistantStore.fetchAndLoadSheets();

      const subsheetsByParentSheetId = {};

      const finalSubsheets =
        (typeof onRequestParams === "function" && (await onRequestParams())) ||
        subsheets;

      for (const sheet of finalSubsheets) {
        const { parentSheetId } = sheet;

        if (!parentSheetId) continue;

        // groups all subsheets by parent sheet
        if (!subsheetsByParentSheetId[parentSheetId]) {
          subsheetsByParentSheetId[parentSheetId] = [];
        }
        subsheetsByParentSheetId[parentSheetId].push(sheet);
      }

      const subsheetsCreated = await createSubsheets(subsheetsByParentSheetId);
      await handleComplete(subsheetsCreated);
    } catch (e) {
      console.log(`e->`, e);
    }
  };

  const renderSubsheetsTaskAction = () => {
    return (
      <Progress progress={progress} parentComponent={component}/>
    );
  };

  useEffect(() => {
    handleOnLoad();
  }, []);

  return renderSubsheetsTaskAction();
};

export default inject(({ store }) => {
  return {
    assistantStore: store.assistantStore,
    chatHelpersStore: store.chatHelpersStore,
  };
})(observer(SubsheetsTaskAction));
